
document.addEventListener("DOMContentLoaded", () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("show");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll(".hidden-left, .hidden-right").forEach((el) => observer.observe(el));
});


document.addEventListener("DOMContentLoaded", () => {
  const boxes = document.querySelectorAll(".image-box");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add("visible"), 200);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.3 }
  );
  boxes.forEach((box) => observer.observe(box));
});

document.addEventListener("DOMContentLoaded", () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add("show", "visible"), i * 150);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  document.querySelectorAll(".from-left, .from-right, .from-top").forEach(el => observer.observe(el));
});




/* Perf: defer offscreen background <video> until near viewport */
(function(){
  function initLazyVideos(root){
    (root||document).querySelectorAll('video.lazy-video').forEach(function(v){
      if(v.dataset.lazyBound) return;
      v.dataset.lazyBound = '1';
      var load = function(){
        var s = v.querySelector('source[data-src]');
        if(s && !s.getAttribute('src')){
          s.setAttribute('src', s.getAttribute('data-src'));
          v.load();
          var p = v.play(); if(p && p.catch){ p.catch(function(){}); }
        }
      };
      if('IntersectionObserver' in window){
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){ if(e.isIntersecting){ load(); io.disconnect(); } });
        }, { rootMargin: '400px 0px' });
        io.observe(v);
      } else { load(); }
    });
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ initLazyVideos(); });
  } else { initLazyVideos(); }
  document.addEventListener('shopify:section:load', function(e){ initLazyVideos(e.target); });
})();
